import { render } from "./UnfinishedStep.vue?vue&type=template&id=2a6550f4"
import script from "./UnfinishedStep.vue?vue&type=script&lang=js"
export * from "./UnfinishedStep.vue?vue&type=script&lang=js"

import "./UnfinishedStep.vue?vue&type=style&index=0&id=2a6550f4&lang=css"

import exportComponent from "/home/zhayrullah/projects/laravel/mawthuq/front-mawthuq/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__